/** Captured from the same world, camera, palette and time (zero) as WebGL. */
export default function ArchitectureFallback() {
  return (
    <div className="ah-fallback" role="img"
      aria-label="Shared ontology above four governed layers: canonical entities, metadata, quality rules and provenance">
      <img className="ah-poster-light" src="/architecture/opener-light.webp" width="1200" height="800" alt="" fetchPriority="high" />
      <img className="ah-poster-dark" src="/architecture/opener-dark.webp" width="1200" height="800" alt="" fetchPriority="high" />
    </div>
  );
}
